<h3>Your Coupons</h3>

<mat-spinner *ngIf="!coupons" color="secondary"></mat-spinner>

<p *ngIf="coupons && coupons.data.length === 0">
  You have no coupons at this time.
</p>

<mat-table #table [dataSource]="coupons" *ngIf="coupons && coupons.data.length > 0">
  <ng-container matColumnDef="Code">
    <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
    <mat-cell *matCellDef="let coupon">{{ coupon.Code }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Description">
    <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
    <mat-cell *matCellDef="let coupon">{{ coupon.Description }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="Action">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell class="text-right" *matCellDef="let coupon">
      <button mat-flat-button [disabled]="coupon.applying" color="secondary" (click)="applyCoupon(coupon)">Apply</button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="['Code','Description','Action']"></mat-header-row>
  <mat-row *matRowDef="let order; columns: ['Code','Description','Action'];"></mat-row>
</mat-table>
